// return the user data from the session storage
export const getUser = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    else return null;
}
export const isLoggedin = () => {
    const userStr = localStorage.getItem('user');
    if(userStr === undefined || userStr===null) {
        return false;
    } else {
        return true;
    }
}
// Null-safe: these run during render in TopHeader/Dashboard/the chat widget,
// which the router mounts before any session check. Dereferencing a missing
// 'user' threw there and took the whole React tree down — a blank page instead
// of a redirect to login.
export const getRole = () => {
    const userStr = JSON.parse(localStorage.getItem('user'));
    return userStr ? userStr.roleID : null;
}
export const watermeter = () => {
    const userStr = JSON.parse(localStorage.getItem('user'));
    return userStr ? userStr.watermeter : null;
}
export const controls = () => {
    const userStr = JSON.parse(localStorage.getItem('user'));
    return userStr ? userStr.controls : null;
}
export const browserDetails = () => {
    const browserInfo = JSON.parse(localStorage.getItem('browserDetails'));
    return browserInfo;
}
// Server-stored UI language for the signed-in user (i18n Phase 4).
// Returns null when there is no session, or when the users.language column /
// migration is not in place — callers then fall back to localStorage 'lang'.
export const getLanguage = () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
        const user = JSON.parse(userStr);
        return user && user.language ? user.language : null;
    } catch (e) {
        return null;
    }
}
export const getUserName = () => {
    const userStr = JSON.parse(localStorage.getItem('user'));
    return userStr ? userStr.userName : null;
}
  
  // return the token from the session storage
    export const getToken = () => {
        return localStorage.getItem('token') || null;
    }
 export const headers = ()=>{
    let header_obj ={
        authorization: "Bearer "+localStorage.getItem('token')
     }  
    return header_obj;
 }
 export const updateBrowserToken = (token)=>{
    const _arr = browserDetails();
    _arr.push(token);
    localStorage.setItem('browserDetails', JSON.stringify(_arr));
    return null;
 }
  
  // remove the token and user from the session storage
  export const removeUserSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('browserDetails');
  }
  
  // set the token and user from the session storage
  export const setUserSession = (token, user, browserDetails, refreshToken ) => {
    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('browserDetails', JSON.stringify(browserDetails))
  }